var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/error.png")}}),_c('v-btn',{attrs:{"x-large":"","color":"primary","outlined":""},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("الرجوع")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }